import React from "react";

// Legacy variant names map onto Polar tones. Good outcomes and statuses
// (success, active) are "positive"; mint "live" is only for a live call, a
// registered line or a met goal; "sample" marks illustrative data.
const TONE = {
  default: "neutral",
  primary: "neutral",
  secondary: "neutral",
  success: "positive",
  active: "positive",
  positive: "positive",
  sample: "sample",
  danger: "danger",
  error: "danger",
  failed: "danger",
  warning: "warn",
  pending: "warn",
  paused: "warn",
  info: "info",
  completed: "info",
  coach: "coach",
  live: "live",
  neutral: "neutral",
  warn: "warn",
};

// Tones that carry a status dot; plain neutral/info pills stay text-only.
const DOT_TONES = new Set(["live", "positive", "coach", "warn", "danger"]);

const Badge = React.memo(
  ({
    children,
    variant = "default",
    size = "md",
    className = "",
    dot,
    ...props
  }) => {
    const tone = TONE[variant] || "neutral";
    const showDot = dot ?? DOT_TONES.has(tone);

    return (
      <span
        className={`sg-badge ${className}`}
        data-tone={tone}
        data-size={size === "lg" || size === "xl" ? "lg" : undefined}
        {...props}
      >
        {showDot && <span className="sg-dot" data-tone={tone} aria-hidden="true" />}
        {children}
      </span>
    );
  },
);

Badge.displayName = "Badge";

export { Badge };
export default Badge;
